import Model from '@/shared/models/plans/PlanPackageModule'
import i18n from '@/plugins/i18n'

export default class PlanPackageModule extends Model {
    constructor(planPackageId = null) {
        super({
            plan_package_id: planPackageId,
        })
    }

    get tableColumns() {
        return [
            {
                text: '#',
                value: 'id',
            },
            {
                text: i18n.t('planPackageModules.index.table.headers.module'),
                value: 'module_name',
            },
            {
                text: i18n.t('planPackageModules.index.table.headers.price'),
                value: 'formattedPrice',
                sortable: false,
                width: 200,
            },
            {
                text: i18n.t(
                    'planPackageModules.index.table.headers.price_type',
                ),
                value: 'price_type',
                sortable: false,
                width: 200,
            },
            {
                text: i18n.t('planPackageModules.index.table.headers.included'),
                value: 'amount',
                sortable: false,
                width: 120,
            },
            {
                text: i18n.t('planPackageModules.index.table.headers.add_on'),
                value: 'add_on',
                sortable: false,
                width: 120,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'edit',
                to: {
                    name: 'planPackageModules.edit',
                    params: { id: this.plan_package_id, module: this.id },
                },
                hide: !this.isDeleted,
            },
            {
                type: 'delete',
                hide: !this.isDeleted || !this.isChannel,
            },
            {
                type: 'restore',
                hide: this.isDeleted || !this.isChannel,
            },
        ]
    }
}
